import { useCallback } from 'react'
import {
  type MessageDescriptor,
  type PrimitiveType,
  useIntl,
  type IntlShape,
} from 'react-intl'
import type { Options, FormatXMLElementFn } from 'intl-messageformat'
import { getCookie } from 'bl-utils/src/cookies'

type FormatMessage = IntlShape['formatMessage']

export function useFormatMessage(): {
  formatMessage: FormatMessage
  locale: string
} {
  const debugMode = getCookie('i18nDebug') === 'on'
  const intl = useIntl()

  const formatMessage = useCallback(
    (
      descriptor: MessageDescriptor,
      values?: Record<
        string,
        PrimitiveType | FormatXMLElementFn<string, string> | React.ReactNode
      >,
      opts?: Options
    ) =>
      debugMode ? descriptor.id : intl.formatMessage(descriptor, values, opts),
    [intl, debugMode]
  ) as FormatMessage

  return {
    formatMessage,
    locale: intl.locale,
  }
}
